export function makeKey(id, variant) {
    const v = typeof variant === "string" ? variant.trim() : "";
    return v ? `${String(id)}::${encodeURIComponent(v)}` : String(id);
}

export function parseKey(key) {
    const [id, maybeVariant] = String(key).split("::");
    return {
        id,
        variant: maybeVariant ? decodeURIComponent(maybeVariant) : ""
    };
}

export function uniqueBaseIds(keys) {
    const set = new Set();
    for (const k of keys) set.add(parseKey(k).id);
    return Array.from(set);
}

export function cookieCount(cookieObj) {
    return cookieObj ? Object.keys(cookieObj).length : 0;
}

export function normaliseCookieValue(val) {
    return {
        timestamp: Date.now(),
        quantity: Math.max(1, Number(val?.quantity ?? 1))
    };
}

export function getAddToKitScope(btn) {
    return btn?.closest("[data-add-to-kit-scope]") || btn?.closest("section") || null;
}

export function getVariantForButton(btn) {
    const scope = getAddToKitScope(btn);
    const select = scope?.querySelector("select[data-equipment-variant]");
    return select?.value || "";
}

export function variantRequiredButMissing(btn) {
    const scope = getAddToKitScope(btn);
    const select = scope?.querySelector("select[data-equipment-variant]");
    if (!select) return false;
    return !select.value;
}
